// client/src/components/ClosurePage.jsx
// Temporary "site closed" screen. Rendered by App.js as a global gate when
// the runtime flag in /site-status.json has { "closed": true }.
import React from 'react';
import '../App.css';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSelector from './LanguageSelector';

const ClosurePage = () => {
  const { t } = useLanguage();

  return (
    <div className="container">
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          padding: '32px 20px',
          maxWidth: '620px',
          margin: '0 auto',
        }}
      >
        <div style={{ marginBottom: '28px' }}>
          <LanguageSelector />
        </div>

        <div style={{ fontSize: '2.75rem', marginBottom: '4px' }} aria-hidden="true">
          🎲
        </div>

        <h1 style={{ fontSize: '1.6rem', marginBottom: '20px', lineHeight: 1.3 }}>
          {t('closure.title')}
        </h1>

        <p style={{ fontSize: '1.05rem', lineHeight: 1.6, marginBottom: '28px' }}>
          {t('closure.intro')}
        </p>

        <h2 style={{ fontSize: '1.2rem', marginBottom: '10px' }}>
          {t('closure.whyTitle')}
        </h2>
        <p style={{ fontSize: '1.05rem', lineHeight: 1.6, marginBottom: '32px' }}>
          {t('closure.whyBody')}
        </p>

        <p style={{ fontSize: '1.05rem', lineHeight: 1.6 }}>
          {t('closure.closingLine')}
        </p>

        <div style={{ marginTop: '20px', lineHeight: 1.4 }}>
          <div style={{ fontWeight: 600 }}>{t('closure.signatureName')}</div>
          <div style={{ color: '#64748b' }}>{t('closure.signatureStudio')}</div>
        </div>
      </div>
    </div>
  );
};

export default ClosurePage;
